import localFont from 'next/font/local';

export interface FontOptions {
  display?: 'swap' | 'block' | 'fallback' | 'optional' | 'auto';
  subsets?: string[];
  variable: string;
  weight?: string[];
}

export interface FontReference {
  variable: string;
}

const agbalumo = localFont({
  src: '../../../public/fonts/agbalumo-400.woff2',
  variable: '--font-agbalumo',
  declarations: [{ prop: 'font-family', value: 'Agbalumo' }],
  weight: '400',
  display: 'swap',
});
const bitter = localFont({
  src: [
    { path: '../../../public/fonts/bitter-variable.woff2', weight: '400' },
    { path: '../../../public/fonts/bitter-variable.woff2', weight: '700' },
  ],
  variable: '--font-bitter',
  declarations: [{ prop: 'font-family', value: 'Bitter' }],
  display: 'swap',
  adjustFontFallback: 'Times New Roman',
});
const boogaloo = localFont({
  src: '../../../public/fonts/boogaloo-400.woff2',
  variable: '--font-boogaloo',
  declarations: [{ prop: 'font-family', value: 'Boogaloo' }],
  weight: '400',
  display: 'swap',
});
const galada = localFont({
  src: '../../../public/fonts/galada-400.woff2',
  variable: '--font-galada',
  declarations: [{ prop: 'font-family', value: 'Galada' }],
  weight: '400',
  display: 'swap',
});
const inter = localFont({
  src: '../../../public/fonts/inter-variable.woff2',
  variable: '--font-inter',
  declarations: [{ prop: 'font-family', value: 'Inter' }],
  weight: '100 900',
  display: 'swap',
});
const jost = localFont({
  src: [
    { path: '../../../public/fonts/jost-variable.woff2', weight: '400' },
    { path: '../../../public/fonts/jost-variable.woff2', weight: '700' },
    { path: '../../../public/fonts/jost-variable.woff2', weight: '800' },
  ],
  variable: '--font-jost',
  declarations: [{ prop: 'font-family', value: 'Jost' }],
  display: 'swap',
});
const lato = localFont({
  src: [
    { path: '../../../public/fonts/lato-400.woff2', weight: '400' },
    { path: '../../../public/fonts/lato-700.woff2', weight: '700' },
  ],
  variable: '--font-lato',
  declarations: [{ prop: 'font-family', value: 'Lato' }],
  display: 'swap',
});
const lexend = localFont({
  src: [
    { path: '../../../public/fonts/lexend-variable.woff2', weight: '400' },
    { path: '../../../public/fonts/lexend-variable.woff2', weight: '700' },
  ],
  variable: '--font-lexend',
  declarations: [{ prop: 'font-family', value: 'Lexend' }],
  display: 'swap',
});
const lora = localFont({
  src: [
    { path: '../../../public/fonts/lora-variable.woff2', weight: '400' },
    { path: '../../../public/fonts/lora-variable.woff2', weight: '600' },
  ],
  variable: '--font-lora',
  declarations: [{ prop: 'font-family', value: 'Lora' }],
  display: 'swap',
  adjustFontFallback: 'Times New Roman',
});
const montserrat = localFont({
  src: [
    { path: '../../../public/fonts/montserrat-variable.woff2', weight: '400' },
    { path: '../../../public/fonts/montserrat-variable.woff2', weight: '800' },
  ],
  variable: '--font-montserrat',
  declarations: [{ prop: 'font-family', value: 'Montserrat' }],
  display: 'swap',
});
const notoSans = localFont({
  src: [
    { path: '../../../public/fonts/noto-sans-variable.woff2', weight: '400' },
    { path: '../../../public/fonts/noto-sans-variable.woff2', weight: '700' },
  ],
  variable: '--font-noto-sans',
  declarations: [{ prop: 'font-family', value: 'Noto Sans' }],
  display: 'swap',
});
const oswald = localFont({
  src: [
    { path: '../../../public/fonts/oswald-variable.woff2', weight: '400' },
    { path: '../../../public/fonts/oswald-variable.woff2', weight: '700' },
  ],
  variable: '--font-oswald',
  declarations: [{ prop: 'font-family', value: 'Oswald' }],
  display: 'swap',
});
const roboto = localFont({
  src: [
    { path: '../../../public/fonts/roboto-variable.woff2', weight: '400' },
    { path: '../../../public/fonts/roboto-variable.woff2', weight: '700' },
  ],
  variable: '--font-roboto',
  declarations: [{ prop: 'font-family', value: 'Roboto' }],
  display: 'swap',
});
const robotoSlab = localFont({
  src: [
    { path: '../../../public/fonts/roboto-slab-variable.woff2', weight: '400' },
    { path: '../../../public/fonts/roboto-slab-variable.woff2', weight: '800' },
  ],
  variable: '--font-roboto-slab',
  declarations: [{ prop: 'font-family', value: 'Roboto Slab' }],
  display: 'swap',
  adjustFontFallback: 'Times New Roman',
});
const slackey = localFont({
  src: '../../../public/fonts/slackey-400.woff2',
  variable: '--font-slackey',
  declarations: [{ prop: 'font-family', value: 'Slackey' }],
  weight: '400',
  display: 'swap',
});
const yellowtail = localFont({
  src: '../../../public/fonts/yellowtail-400.woff2',
  variable: '--font-yellowtail',
  declarations: [{ prop: 'font-family', value: 'Yellowtail' }],
  weight: '400',
  display: 'swap',
});
const zillaSlab = localFont({
  src: [
    { path: '../../../public/fonts/zilla-slab-400.woff2', weight: '400' },
    { path: '../../../public/fonts/zilla-slab-700.woff2', weight: '700' },
  ],
  variable: '--font-zilla-slab',
  declarations: [{ prop: 'font-family', value: 'Zilla Slab' }],
  display: 'swap',
  adjustFontFallback: 'Times New Roman',
});

const fonts: Record<string, FontReference> = {
  '--font-agbalumo': agbalumo,
  '--font-bitter': bitter,
  '--font-boogaloo': boogaloo,
  '--font-galada': galada,
  '--font-inter': inter,
  '--font-jost': jost,
  '--font-lato': lato,
  '--font-lexend': lexend,
  '--font-lora': lora,
  '--font-montserrat': montserrat,
  '--font-noto-sans': notoSans,
  '--font-oswald': oswald,
  '--font-roboto': roboto,
  '--font-roboto-slab': robotoSlab,
  '--font-slackey': slackey,
  '--font-yellowtail': yellowtail,
  '--font-zilla-slab': zillaSlab,
};

function localFontReference({ variable }: FontOptions): FontReference {
  const font = fonts[variable];
  if (!font) {
    throw new Error(`Unsupported font variable: ${variable}`);
  }
  return font;
}

export {
  localFontReference as Agbalumo,
  localFontReference as Bitter,
  localFontReference as Boogaloo,
  localFontReference as Galada,
  localFontReference as Inter,
  localFontReference as Jost,
  localFontReference as Lato,
  localFontReference as Lexend,
  localFontReference as Lora,
  localFontReference as Montserrat,
  localFontReference as Noto_Sans,
  localFontReference as Oswald,
  localFontReference as Roboto,
  localFontReference as Roboto_Slab,
  localFontReference as Slackey,
  localFontReference as Yellowtail,
  localFontReference as Zilla_Slab,
};
